<script>
/* eslint-disable semi */
import { Vue, Component } from 'vue-property-decorator';

const debug = process.env.NODE_ENV === 'development';

@Component
export default class SasComponent extends Vue {
  ignore (...args) {}

  /**
   * SSR対応 LifeCycleイベント
   */
  serverPrefetch () {
    return this.initialize() || Promise.resolve();
  }

  /**
   * LifeCycleイベント
   * コンポーネントがマウントされたタイミングで初期化処理を実行する
   */
  mounted () {
    this.initialize();
  }

  /**
   * 初期化処理
   * オーバーライドする場合はPromiseを返却するようにしてください。
   */
  initialize () {
    if (debug) {
      console.debug('SasComponent initialize called.');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/core/ui/SasComponent.vue